import React, { PureComponent /*, PropTypes*/ } from 'react';
// import IPropTypes from 'react-immutable-proptypes'
import { Formik, Form, Field } from 'formik';

import './styles.scss';
import get from 'lodash/get';

export default class LinkComponent extends PureComponent {
  static propTypes = {
    // PropTypes go here
  };

  addInsight = formData => {
    const {
      insight,
      match: {
        params: { townId }
      }
    } = this.props;

    let data = {
      ...formData,
      id: get(insight, 'id', 0),
      town_id: townId,
      type: 'education',
      file: '',
      insight_type: "link",
      created_by: this.props.user.id,
      is_external: 1,
      fileName: '',
    };

    this.props.addInsight(data)
  }

  render() {
    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={get(this, "props.insight", {})}
          onSubmit={this.addInsight}
        >
          {({
            isSubmitting,
            errors,
            setFieldValue,
            values,
            handleBlur,
            handleChange
          }) => (
            <Form>
              <div className="form-group material-textfield">
                <Field
                  type="text"
                  name="link"
                  className="form-control material-textfield-input textfield-input-lg"
                  required
                />
                <label className="material-textfield-label label-lg">
                  Enter URL
                </label>
              </div>
              <div className="form-group material-textfield">
                <Field
                  as="textarea"
                  name="note"
                  className="form-control material-textfield-input textfield-input-lg"
                  rows="6"
                  required
                />
                <label className="material-textfield-label label-lg">
                  Add a note about your link...{' '}
                </label>
              </div>

              <button
                hidden
                ref={this.props.submitBtnRef}
                type="submit"
                className="btn btn__btn btn-dark btn__lg w__100"
              >
                Save
              </button>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}
